import React from 'react';
import OnboardingModule from './routes/ModuleRoutes';

// eslint-disable-next-line react/display-name
export default () => {
  return (
    <OnboardingModule/>
  );
};
